<ng-template #inputContent>
  <ng-content></ng-content>
</ng-template>

<div [className]="'float-start w-100 ' + wrapperClass">
  @if (isPlatformBrowser) {
    <div role="list" class="nav nav-pills d-flex flex-column flex-sm-row" cdkDropListGroup>
      @for (c of chips.getChips(); track c; let i = $index) {
        <ng-container>
          <ng-template #tipContent>
            @for (tip of (tipText$ | async); track tip) {
              <p class="text-start p-0 m-0">
                {{tip}}
              </p>
            }
          </ng-template>
          <div role="listitem" class="nav-item me-2 mb-1 d-flex flex-row"
               #t="ngbTooltip"
               triggers="manual"
               cdkDropList
               [cdkDropListData]="{ index: i }"
               cdkDropListOrientation="horizontal"
               (cdkDropListDropped)="onDrop($event)"
               [ngbTooltip]="tipContent"
               (mouseover)="showTooltip(t, i)"
               (mouseout)="t.close()">
            <a class="flex-sm-fill text-sm-center nav-link active bg-info"
               cdkDrag
               (cdkDragStarted)="onDrag(i)"
               href="#"
               [class.disabled]="!clickable || (editable && c.editMode) || dragged === i  "
               [class.chip-selected]="(editable && c.editMode) || dragged === i"
               (click)="chipsSelected($event, i);">
              <span>
                @if (showIcons && !c.isNestedItem()) {
                  <i dsAuthorityConfidenceState [authorityValue]="c.item" class="far fa-circle" aria-hidden="true">&nbsp;</i>
                }
                @if (showIcons && c.hasVisibleIcons()) {
                  <ng-container>
                    @for (icon of c.icons; track icon; let l = $last) {
                      <span class="chip-stacked-icons">
                        <i [ngbTooltip]="tipContent"
                           placement="right"
                           triggers="manual"
                           #t="ngbTooltip"
                           class="{{icon.style}}"
                           [class.me-1]="!l"
                           [class.me-2]="l"
                           dsAuthorityConfidenceState
                           [authorityValue]="c.item[icon.metadata] || c.item"
                           [visibleWhenAuthorityEmpty]="icon.visibleWhenAuthorityEmpty"
                           [showTooltip]="false"
                           aria-hidden="true"
                           (mouseover)="showTooltip(t, i, icon.metadata)"
                           (mouseout)="t.close()"></i>
                        @if (hasWillBeGenerated(c, icon.metadata)) {
                          <i dsAuthorityConfidenceState
                             [authorityValue]="c.item[icon.metadata] || c.item"
                             [visibleWhenAuthorityEmpty]="icon.visibleWhenAuthorityEmpty"
                             class="fas fa-plus fa-stack-1x chip-stacked-icon"></i>
                        }
                        @if (hasWillBeReferenced(c, icon.metadata)) {
                          <i dsAuthorityConfidenceState
                             [authorityValue]="c.item[icon.metadata] || c.item"
                             [visibleWhenAuthorityEmpty]="icon.visibleWhenAuthorityEmpty"
                             class="fas fa-search fa-stack-1x chip-stacked-icon"></i>
                        }
                      </span>
                    }

                  </ng-container>
                }
               <p class="d-table-cell">{{textTruncate(c.display)}}</p>
                @if (editable) {
                  <i class="fas fa-times ms-2"
                     (click)="removeChips($event, i)"
                     [title]="'chips.remove' | translate"></i>
                }
              </span>
            </a>
          </div>
        </ng-container>
      }
      <div [class.chips-sort-ignore]="(isDragging | async)" class="flex-grow-1">
        <ng-container *ngTemplateOutlet="inputContent"></ng-container>
      </div>
    </div>
  }
  @if (!isPlatformBrowser) {
    <div role="list" class="nav nav-pills d-flex flex-column flex-sm-row">
    @for (c of chips.getChips(); track c; let i = $index) {
      <ng-template #tipContent>
        @for (tip of (tipText$ | async); track tip) {
          <p class="text-start p-0 m-0">
            {{tip}}
          </p>
        }
      </ng-template>

      <div role="listitem" class="nav-item me-2 mb-1">
        <a class="flex-sm-fill text-sm-center nav-link active bg-info"
           href="javascript:void(0);">
          <span>
            @if (showIcons && !c.isNestedItem()) {
              <i dsAuthorityConfidenceState [authorityValue]="c.item" class="far fa-circle" aria-hidden="true"></i>
            }
            @if (showIcons && c.hasVisibleIcons()) {
              @for (icon of c.icons; track icon; let l = $last) {
                <span class="chip-stacked-icons">
                <i class="{{icon.style}}"
                   [class.me-1]="!l"
                   [class.me-2]="l"
                   dsAuthorityConfidenceState
                   [authorityValue]="c.item[icon.metadata] || c.item"
                   [visibleWhenAuthorityEmpty]="icon.visibleWhenAuthorityEmpty"
                   [showTooltip]="false"
                   aria-hidden="true"></i>
                @if (hasWillBeGenerated(c, icon.metadata)) {
                  <i dsAuthorityConfidenceState
                     [authorityValue]="c.item[icon.metadata] || c.item"
                     [visibleWhenAuthorityEmpty]="icon.visibleWhenAuthorityEmpty"
                     class="fas fa-plus fa-stack-1x chip-stacked-icon"></i>
                }
                @if (hasWillBeReferenced(c, icon.metadata)) {
                  <i dsAuthorityConfidenceState
                     [authorityValue]="c.item[icon.metadata] || c.item"
                     [visibleWhenAuthorityEmpty]="icon.visibleWhenAuthorityEmpty"
                     class="fas fa-search fa-stack-1x chip-stacked-icon"></i>
                }
              </span>
              }
            }
           <p class="d-table-cell">{{textTruncate(c.display)}}</p>
            @if (editable) {
              <i class="fas fa-times ms-2"
                 (click)="removeChips($event, i)"
                 [title]="'chips.remove' | translate"></i>
            }
          </span>
        </a>
      </div>
  }
    <div [class.chips-sort-ignore]="(isDragging | async)" class="flex-grow-1">
      <ng-container *ngTemplateOutlet="inputContent"></ng-container>
    </div>
  </div>
  }
</div>
